import { createAction } from 'redux-act'

export const getManagers = createAction('Get Managers Request')
export const getManagersSuccessful = createAction('Get Manager Request Success')
export const getManagersFailure = createAction('Get Manager Request Fail')

export const getManagerRequests = createAction('Get Manager Requests')
export const getManagerRequestsSuccessful = createAction('Get Manager Requests Success')
export const getManagerRequestsFailure = createAction('Get Manager Requests Fail')

export const costConfirm = createAction('Confirm Cost')
export const confirmAllCosts = createAction('Confirm All Costs')
export const costCancel = createAction('Cancel Cost')
